import { css } from '@emotion/react';
import { theme } from '@arc/frontend/ui-theme';
import { ButtonIconDelete } from './ButtonIconDelete';
const styles = {
  inlineButton: /*#__PURE__*/css({
    backgroundColor: theme.colors.white,
    display: 'grid',
    width: '2rem',
    height: '2rem',
    cursor: 'pointer',
    placeItems: 'center',
    borderBottomLeftRadius: '0.375rem',
    borderBottomRightRadius: '0.375rem',
    filter: 'drop-shadow(0px 8px 12px #0000001f);'
  }, process.env.NODE_ENV === "production" ? "" : ";label:inlineButton;")
};
export function ButtonIconDeleteInline(props) {
  return <div {...props} css={styles.inlineButton}>
			<ButtonIconDelete />
		</div>;
}